export const ANALYTICS_STALE_TIME = 1000 * 60 * 5; // 5 minutes

/** The version of what viewers saw outside a publication (Studio previews). */
export const PREVIEW_VERSION = "preview";
/** Every version at once. */
export const ALL_VERSIONS = "all";
/** The URL search param holding the picked version. */
export const VERSION_PARAM = "version";

export const TARGETS = {
  general: {
    average_duration: 300,
    average_events: 1000,
    chat_interactions: 1500,
  },
  videoExplainer: {
    avg_completion_pct: 90,
    chat_rate_pct: 50,
    full_completers_pct: 85,
    play_rate: 80,
    median_drop_seconds: 60,
  },
  documentHighlighter: {
    avg_reading_depth_pct: 80,
    backtrack_rate_pct: 50,
    full_completers_pct: 90,
    scroll_rate_pct: 90,
  },
  aiChatbot: {
    avg_chat_duration_seconds: 300,
    avg_confusion_score: 0.1,
    chat_rate_pct: 20,
    convinced_sessions: 15,
    total_chat_sessions: 5,
  },
};

export const PREFIXES = {
  activity: "media.projects.analytics.activity",
};
